import React from 'react'

const OpenTrades = ({color, size}) => {
    return (
        <svg width="800px" height="800px" viewBox="0 0 24 24" fill='none' className={`size-${size || 6}`}>
            <path d="M12 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M8 13V17M16 11V17M12 7V17M5 8V2M2 5H8" stroke={`${color}`} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
  )
}

export default OpenTrades